import JainismPage from "../jainism/JainismPage";

export default function Jainism() {
  return (
    <>
      <JainismPage />
    </>
  );
}
